import React, { useEffect } from "react";

const Contact = (props) => {
  useEffect(() => {
    document.title = "Contact ME";
  }, []);

  let mycolor = "#C7A4B3";

  if (props.color !== mycolor) props.backColor(mycolor);

  return (
    <div>
      <h1
        className="ui header"
        style={{
          marginTop: "15px",
          marginLeft: "20px",
          color: "purple",
          fontSize: "35px",
        }}
      >
        Contact💬💬
      </h1>
      <div className="ui container" style={{ width: "500px" }}>
        <form className="ui form" action="/" method="POST">
          <div className="required field">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter your Name"
              id="name"
            />
          </div>
          <div className="required field">
            <label htmlFor="mail">Email</label>
            <input
              type="email"
              name="mail"
              placeholder="Enter your Email"
              id="mail"
            />
          </div>
          <div className="required field">
            <label>Message</label>
            <textarea placeholder="Enter your message!!" rows="2"></textarea>
          </div>
          <button className="ui button">Submit</button>
          <span class="ui sub header">
            <sub>Under Construction</sub>
          </span>
        </form>
      </div>
      <div className="ui horizontal divider" style={{ fontSize: "20px" }}>
        Or<sub style={{ fontSize: "10px" }}> Directly Message Me At</sub>
      </div>
      <div className="ui segment inverted">
        <h3>Email📧📧 : sakshammanocha14@gmail.com</h3>
        <br></br>
        Phone No📞📞 : 8587058526
      </div>
    </div>
  );
};

export default Contact;
